module.exports = __webpack_public_path__ + "./docs/img/icon-root.abe5939a1cdfd9f88fd09786d9db14fa.svg";